<template>
    <div>
        <div class="mb-3 d-flex" style="font-size:x-small;">
            <div class="col-lg-7 col-md-6"></div>
            <div class="d-flex col-lg-5 col-md-6 col-12">
                <div class="input-group flex-grow-1">
                    <input v-model="search" type="search" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="event-search" @keydown.enter="updateData">

                    <button class="btn btn-outline-secondary text-dark dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="false" aria-expanded="false" data-bs-offset="0,8"></button>

                    <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                            <date-picker class="dropdown-item" v-model="start" placeholder="Start date" value-type="YYYY-MM-DD" @change="updateData"></date-picker>
                        </li>
                        <li>
                            <date-picker class="dropdown-item" v-model="end" placeholder="End date" value-type="YYYY-MM-DD" @change="updateData"></date-picker>
                        </li>
                        <li>
                            <div class="dropdown-item">
                                <input v-model="inactive" @change="updateData" class="form-check-input" type="checkbox" value="" id="show-inactive">
                                <label class="form-check-label" for="show-inactive">
                                    Show inactive events
                                </label>
                            </div>
                        </li>
                    </ul>
                    <button class="btn btn-secondary" @click="updateData">
                        <i class="fas fa-search me-2"></i><span class="d-none d-lg-inline">Search</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    components: { DatePicker },

    props: {
        value: {
            type: Object,
            default: function({}) { return {};}
        }
    },

    mounted() {
        this.search = this.$route.query.search ?? '';
        this.inactive = Boolean(this.$route.query.inactive ?? false);
        this.start = this.$route.query.start ?? null;
        this.end = this.$route.query.end ?? null;
    },

    methods: {
        updateData: function() {
            const data = {
                search: this.search,
                inactive: this.inactive,
                start: this.start,
                end: this.end,
            };
            this.$emit('input', data);
        }
    },

    data() {
        return {
            search: '',
            inactive: true,
            start: null,
            end: null,
        };
    },

}
</script>